/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Quand le cabinet du courtier règle les cotisations : le gérant (juridique) du cabinet, seul signataire du mandat, et la place du connecté. Absent quand le souscripteur règle.
 * @export
 * @interface CabinetMandateDto
 */
export interface CabinetMandateDto {
    /**
     * 
     * @type {string}
     * @memberof CabinetMandateDto
     */
    cabinetName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CabinetMandateDto
     */
    hasGerant?: boolean;
    /**
     * Gérant nommé par la carte quand le connecté n'est pas lui.
     * @type {string}
     * @memberof CabinetMandateDto
     */
    gerantName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CabinetMandateDto
     */
    gerantHasAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CabinetMandateDto
     */
    currentIsGerant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CabinetMandateDto
     */
    currentIsOwner?: boolean;
}

/**
 * Check if a given object implements the CabinetMandateDto interface.
 */
export function instanceOfCabinetMandateDto(value: object): value is CabinetMandateDto {
    return true;
}

export function CabinetMandateDtoFromJSON(json: any): CabinetMandateDto {
    return CabinetMandateDtoFromJSONTyped(json, false);
}

export function CabinetMandateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinetMandateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cabinetName': json['cabinetName'] == null ? undefined : json['cabinetName'],
        'hasGerant': json['hasGerant'] == null ? undefined : json['hasGerant'],
        'gerantName': json['gerantName'] == null ? undefined : json['gerantName'],
        'gerantHasAccess': json['gerantHasAccess'] == null ? undefined : json['gerantHasAccess'],
        'currentIsGerant': json['currentIsGerant'] == null ? undefined : json['currentIsGerant'],
        'currentIsOwner': json['currentIsOwner'] == null ? undefined : json['currentIsOwner'],
    };
}

export function CabinetMandateDtoToJSON(json: any): CabinetMandateDto {
    return CabinetMandateDtoToJSONTyped(json, false);
}

export function CabinetMandateDtoToJSONTyped(value?: CabinetMandateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cabinetName': value['cabinetName'],
        'hasGerant': value['hasGerant'],
        'gerantName': value['gerantName'],
        'gerantHasAccess': value['gerantHasAccess'],
        'currentIsGerant': value['currentIsGerant'],
        'currentIsOwner': value['currentIsOwner'],
    };
}

